import React, { useEffect, useRef, useState } from 'react';

// A small banner at the top when the visitor finds a secret: "🦉 Night owl, aren't you?  · Secret 3 of 14",
// or with the greeting on a festival day.
const EggToast = () => {
  const [egg, setEgg] = useState(null);
  const timer = useRef();
  useEffect(() => {
    const show = (e) => {
      setEgg(e.detail);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setEgg(null), 6000);
    };
    window.addEventListener('gallery-egg', show);
    return () => { window.removeEventListener('gallery-egg', show); clearTimeout(timer.current); };
  }, []);
  if (!egg) return null;
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[60] pointer-events-none px-4 w-full max-w-md" role="status" aria-live="polite">
      <div className="bg-gray-900/85 text-white backdrop-blur-sm rounded-2xl shadow-2xl px-4 py-3 flex items-center gap-3 animate-in fade-in slide-in-from-top-2 duration-500">
        <span className="text-2xl" aria-hidden="true">{egg.icon}</span>
        <div className="flex-1">
          <div className="text-sm font-medium leading-snug">{egg.message}</div>
          <div className="text-[11px] text-amber-300/90 mt-0.5">
            {egg.festival ? `Celebrating ${egg.festival} around the world` : `Secret ${egg.found} of ${egg.total} found`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EggToast;
